import React, { useContext, useEffect, useState } from 'react';
import {
    Route,
    RouteComponentProps,
    RouteProps,
    Redirect,
    useHistory
} from 'react-router-dom';
import { Step, getStep, setStep } from 'actions/step.action';
import { defaultApplicationRoutes, RoutePath } from 'configs/routes';
import { Wrapper } from 'components/commons';
import { registerPageView } from 'configs/trackers';
import { LoanApplicationContext } from 'containers/context/useGetLoanApplication';

export type RouteParams = {
    loanApplicationId: string;
}

const CustomRoute: React.FC<RouteProps> = (routeProps: RouteProps) => {
    const { component: Container, ...othersProps } = routeProps;
    const [ currentRoute, setCurrentRoute ] = useState(null);
    const { loanApplicationId } = useContext(LoanApplicationContext);

    const { location: { pathname } } = useHistory();

    useEffect(() => {
        defaultApplicationRoutes
            .filter(route => route.path === pathname)
            .forEach(({ pathToTrack}) => {
                setCurrentRoute(pathToTrack);
            });
    },[pathname])

    useEffect(() => {
        if (currentRoute !== null) {
            registerPageView(currentRoute);
        }
    }, [currentRoute]);

    return (
        <Route
            {...othersProps}
            render={(componentProps: RouteComponentProps<RouteParams>) => {
                const currentPath = componentProps.match.path as RoutePath;
                const id = loanApplicationId ?? null;
                const handle = handleRoutes
                    .filter(({ paths }: HandleRoutesProps) => paths.includes(currentPath))
                    .map((item: HandleRoutesProps) => item.handle({ componentProps, routeProps,  loanApplication:id }))[0];

                if (handle) {
                    return handle();
                }

                let ScreenWrapper = Wrapper;

                defaultApplicationRoutes
                    .filter(route => route.path === currentPath)
                    .forEach(({ wrapper }) => {
                        if (wrapper) {
                            ScreenWrapper = wrapper;
                        }
                    });

                return (
                    <ScreenWrapper>
                        <Container {...componentProps} />
                    </ScreenWrapper>
                );
            }}
        />
    );
};

type HandleProps = {
    routeProps: RouteProps;
    componentProps: RouteComponentProps<RouteParams>;
    loanApplication?: string;
};

type HandleRoutesProps = {
    paths: RoutePath[];
    handle(props: HandleProps): any;
};

const handleRoutes: HandleRoutesProps[] = [
    {
        paths: [
            '/motivo',
            '/dados-pessoais',
            '/sobre-a-empresa',
            '/termos-de-uso',
            '/analise',
        ],
        handle: ({ loanApplication, componentProps: { location: { search } } }) => {
            if (!loanApplication) {
                return () => (
                    <Redirect to={{ pathname: '/', search }} />
                );
            }

            return null;
        },
    },
    {
        paths: [
            '/:loanApplicationId',
        ],
        handle: ({ routeProps: { component: Container }, componentProps }) => {
            setStep(Step.BALCAO);

            return () => (
                <Wrapper>
                    <Container {...componentProps} />
                </Wrapper>
            );
        },
    },
    {
        paths: [
            '/:loanApplicationId/configuracao',
            '/:loanApplicationId/endereco',
            '/:loanApplicationId/dados-bancarios',
            '/:loanApplicationId/confirmacao',
            '/:loanApplicationId/resumo',
            '/:loanApplicationId/identificacao',
            '/:loanApplicationId/identificacao/prova-de-vida',
            '/:loanApplicationId/identificacao/questionario',
            '/:loanApplicationId/documentacao',
            '/:loanApplicationId/resumo',
            '/:loanApplicationId/error',
        ],
        handle: ({ componentProps: { match: { params: { loanApplicationId }} } }) => {
            const currentStep = getStep();

            if (currentStep === Step.DIRETO) {
                return () => <Redirect to={{ pathname: `/${loanApplicationId}` }} />;
            }

            return null;
        },
    },
    {
        paths: [
            '/:loanApplicationId/confirmacao',
        ],
        handle: () => {
            if (getStep() !== Step.BALCAO) {
                return () => (
                    <Redirect to={{ pathname: '/' }} />
                );
            }

            return null;
        },
    },
    {
        paths: [
            '/email-cadastrado',
            '/bem-vindo',
        ],
        handle: () => {
            if (getStep() === Step.DIRETO) {
                return () => (
                    <Redirect to={{ pathname: '/' }} />
                );
            }

            return null;
        },
    },
];

export default CustomRoute;
